import React, { useContext, useEffect, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import { BackgroundContext } from '../../libs/BackgroundProvider';
import { useGameContext } from "../../libs/GameProvider";
import CountDown from '../game-common/CountDown';
import SvgButton from '../ui/SvgButton';
import GameCompassHintsAndDescriptionModal from './GameCompassHintsAndDescriptionModal';
import GameCompassPreGame from './GameCompassPreGame';
import MazeBuilder from './MazeBuilder';

interface GameCompassGameProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish?: () => void;
}

type TileType = "dock_v" | "dock_v_b" | "dock"
  | "wave"
  | "dest"
  // | "dest_up" | "dest_right" | "dest_bottom" | "dest_left"
  // | "start"
  | "land"
  // | "_random_"
  // | "tile_land" | "island-nw" | "island-n" | "island-ne" | "island-w" | "island-e" | "island-sw" | "island-s" | "island-se"
  ;

interface NauticalCharts { pos: number, dir: 'n' | 'w' | 's' | 'e', map: Array<Array<TileType>> }
const NAUTICALCHARTS: { [key: number]: Array<NauticalCharts> } = {
  1: [
    {
      pos: 6, dir: 'n', map: [
        ["land"], ["land"], ["dock_v", "dest"],
        ["wave"], ["wave"], ["wave"],
        ["wave"], ["land"], ["land"],
      ]
    },
    {
      pos: 6, dir: 'n', map: [
        ["land"], ["dock_v", "dest"], ["land"],
        ["wave"], ["wave"], ["land"],
        ["wave"], ["land"], ["wave"],
      ]
    },
    {
      pos: 2, dir: 'w', map: [
        ["land"], ["wave"], ["wave"],
        ["wave"], ["wave"], ["land"],
        ["wave"], ["dock_v", "dest"], ["land"],
      ]
    },
    {
      pos: 0, dir: 'e', map: [
        ["wave"], ["wave"], ["land"],
        ["land"], ["wave"], ["wave"],
        ["dock", "dest"], ['wave'], ["land"],
      ]
    },
    {
      pos: 0, dir: 'e', map: [
        ["wave"], ["wave"], ["wave"],
        ["land"], ["land"], ["wave"],
        ["dock", "dest"], ['wave'], ["wave"],
      ]
    },
    {
      pos: 0, dir: 's', map: [
        ["wave"], ["land"], ["dock_v", "dest"],
        ["wave"], ["wave"], ["wave"],
        ["wave"], ['land'], ["wave"],
      ]
    },
  ],
  3: [
    {
      pos: 0, dir: 's', map: [
        ["wave"], ["land"], ["land"], ["land"], ["land"], ["dock_v", "dest"],
        ["wave"], ["wave"], ["wave"], ["wave"], ["wave"], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['land'], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['land'], ["wave"],
        ["wave"], ["wave"], ["wave"], ["wave"], ["wave"], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['land'], ["wave"],
      ]
    },
    {
      pos: 3, dir: 's', map: [
        ["wave"], ["land"], ["land"], ["wave"], ["land"], ["land"],
        ["wave"], ["wave"], ["wave"], ["wave"], ["wave"], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['land'], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['land'], ["wave"],
        ["wave"], ["wave"], ["wave"], ["wave"], ["wave"], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ["dock_v_b", "dest"], ["wave"],
      ]
    },
    {
      pos: 12, dir: 's', map: [
        ["wave"], ["land"], ["land"], ["wave"], ["land"], ["land"],
        ["wave"], ["wave"], ["wave"], ["wave"], ["wave"], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['land'], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['land'], ["wave"],
        ["wave"], ["wave"], ["wave"], ["land"], ["wave"], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ["dock_v_b", "dest"], ["wave"],
      ]
    },
    {
      pos: 6, dir: 's', map: [
        ["wave"], ["land"], ["land"], ["wave"], ["land"], ["land"],
        ["wave"], ["wave"], ["wave"], ["land"], ["wave"], ["wave"],
        ["wave"], ['land'], ['wave'], ['land'], ['land'], ["wave"],
        ["wave"], ['land'], ['wave'], ['wave'], ['wave'], ["wave"],
        ["wave"], ["wave"], ["wave"], ["land"], ["wave"], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ["dock_v_b", "dest"], ["wave"],
      ]
    },
    {
      pos: 11, dir: 's', map: [
        ["land"], ["dock_v", "dest"], ["land"], ["wave"], ["land"], ["land"],
        ["wave"], ["wave"], ["wave"], ["land"], ["land"], ["wave"],
        ["wave"], ['land'], ['wave'], ['land'], ['land'], ["wave"],
        ["wave"], ['land'], ['land'], ['land'], ['wave'], ["wave"],
        ["wave"], ["wave"], ["land"], ["wave"], ["wave"], ["wave"],
        ["wave"], ['wave'], ['wave'], ['wave'], ["land"], ["wave"],
      ]
    },
  ]
};
//
// const NauticalChartsGenerator: (i: number) => any = (i: number) => {
//   let maze = new MazeBuilder(i, i);
//   let map: Array<Array<TileType>> = [];
//   maze.maze.slice(1, -1).forEach(x => x.slice(1, -1).forEach(y => map.push(-1 === y.indexOf('wall') ? ['wave'] : ['land'])));
//   let pos = 0;
//
//   maze.maze.forEach((row, rowIndex) => {
//     row.forEach((col, colIndex) => {
//       if (-1 !== col.indexOf('entrance')) {
//         if (0 === rowIndex) {
//           console.log('pos case a');
//           pos = colIndex - 1;
//         } else if (i * 2 === rowIndex) {
//           console.log('pos case b', rowIndex, i, colIndex);
//           pos = (rowIndex - 2) * i * 2 + colIndex - 1;
//         } else if (0 === colIndex) {
//           console.log('pos case c');
//           pos = (rowIndex - 1) * i * 2;
//         } else if (i * 2 === colIndex) {
//           console.log('pos case d');
//           pos = (rowIndex - 1) * i * 2 + colIndex - 1;
//         }
//       } else if (-1 !== col.indexOf('exit')) {
//
//       }
//     })
//   });
//
//     console.log(maze.maze, map, pos);
//
//   return {
//     pos,
//     dir: 's',
//     map,
//   }
// }

// 0, 1, 2
// 3, 4, 5
// 6, 7, 8
const DirectionOrder = ['n', 'e', 's', 'w',];
const DirectionCheckMapGenerator = (i: number) => Array(i).fill(null).map((_x, rowIndex) => Array(i).fill(null).map((_y, colIndex) => ([
  0 === rowIndex ? null : (rowIndex - 1) * i + colIndex,
  (i - 1) === colIndex ? null : (rowIndex * i + colIndex + 1),
  (i - 1) === rowIndex ? null : ((rowIndex + 1) * i + colIndex),
  0 === colIndex ? null : (rowIndex * i + colIndex - 1),
]))).flat()
const DirectionCheckMap: { [key: number]: Array<Array<null | number>> } = {
  // 1: [
  //   [null, 1, 3, null], [null, 2, 4, 0], [null, null, 5, 1],
  //   [0, 4, 6, null], [1, 5, 7, 3], [2, null, 8, 4,],
  //   [3, 7, null, null], [4, 8, null, 6], [5, null, null, 7],
  // ],
  1: DirectionCheckMapGenerator(3),
  3: DirectionCheckMapGenerator(6),
};

function GameCompassGame(_props: GameCompassGameProps) {
  const { playClick } = useContext(AudioContext);
  const { setBg } = useContext(BackgroundContext);
  const { game, gameDifficulty, dispatch } = useGameContext();
  const [started, setStarted] = useState(false);
  // const [stopped, setStopped] = useState(false);
  const [nauticalChart] = useState<NauticalCharts>(NAUTICALCHARTS[gameDifficulty.difficulty][Math.floor(Math.random() * NAUTICALCHARTS[gameDifficulty.difficulty].length)]);
  // const [nauticalChart] = useState<NauticalCharts>(NauticalChartsGenerator(1 === gameDifficulty.difficulty ? 2 : 3));
  const [currentPos, setCurrentPos] = useState(nauticalChart.pos);
  const [currentDir, setCurrentDir] = useState(nauticalChart.dir);
  const [pinDir, setPinDir] = useState<'' | 'n' | 'e' | 's' | 'w'>('');
  const [shipState, setShipState] = useState<'' | 'failed'>('');
  const [shipMoveState, setShipMoveState] = useState<'' | 'n' | 'e' | 's' | 'w' | 'n-success' | 'e-success' | 's-success' | 'w-success'>('');
  const [controlsDisabled, setControlsDisabled] = useState<Array<'' | 'disabled'>>(['', '', '', '']);

  useEffect(() => {
    if ('game-compass' === game.status) {
      setBg(null);
    }
    // console.log("NauticalChartsGenerator", NauticalChartsGenerator);
    console.log("nauticalChart", nauticalChart);
  }, [game, setBg]);

  // useEffect(() => {
  //   if (3 === gameDifficulty.difficulty) {
  //     setControlsDisabled(DirectionCheckMap[currentPos].map((board) => (null === board) ? 'disabled' : ''));
  //   } else if (1 === gameDifficulty.difficulty) {
  //     setControlsDisabled(DirectionCheckMap[currentPos].map((board) => (null === board
  //       || (-1 === nauticalChart.map[board].indexOf('wave') && -1 === nauticalChart.map[board].indexOf('dest'))
  //     ) ? 'disabled' : ''));
  //   }
  // }, [currentPos, gameDifficulty.difficulty]);

  const timesout = () => {
    dispatch({ type: 'game-compass', state: 'fail' })
  }

  const onControlClick = (direction: 'n' | 'e' | 's' | 'w') => () => {



    let nextPos = DirectionCheckMap[gameDifficulty.difficulty][currentPos][DirectionOrder.indexOf(direction)];
    console.log(DirectionCheckMap[gameDifficulty.difficulty][currentPos], DirectionCheckMap);

    setCurrentDir(direction);
    playClick();
    // console.log('onControlClick', nextPos, DirectionCheckMap[currentPos], DirectionOrder.indexOf(direction), DirectionCheckMap[currentPos][DirectionOrder.indexOf(direction)]);
    if (null === nextPos) {
      console.log('failed 1');
      setShipState('failed');
      setTimeout(() => setShipState(''), 1000);
    } else {
      if (-1 !== nauticalChart.map[nextPos].indexOf('dest')) {
        console.log('success!');
        setCurrentDir(direction);
        setShipMoveState(direction + "-success" as any);
        setTimeout(() => {
          dispatch({ type: 'game-compass', state: 'success' })
        }, 1500);
      } else if (-1 === nauticalChart.map[nextPos].indexOf('wave')) {
        console.log('failed 2');
        setShipState('failed');
        setTimeout(() => setShipState(''), 1000);
      } else {
        console.log(nextPos);
        setShipMoveState(direction);
        setTimeout(() => {
          setCurrentPos(nextPos as number)
          setShipMoveState('');
        }, 1000);
        ;
      }
    }
  }

  const onIntroFinish = () => {
    setStarted(true);
  }

  return (
    <div className="fullscreen">
      <div className="">
        <CountDown started={started} stopped={false} timesout={timesout}></CountDown>

        <div className="compass">
          <div className={`compass-pin`}></div>
        </div>

        <div className="controls">
          <div className={`controls-n controls-${controlsDisabled[0]}`} onClick={onControlClick('n')}><SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/arrow-north-button`} src1=".svg" src2="-select.svg" alt="北"></SvgButton></div>
          <div className={`controls-e controls-${controlsDisabled[1]}`} onClick={onControlClick('e')}><SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/arrow-east-button`} src1=".svg" src2="-select.svg" alt="東"></SvgButton></div>
          <div className={`controls-s controls-${controlsDisabled[2]}`} onClick={onControlClick('s')}><SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/arrow-south-button`} src1=".svg" src2="-select.svg" alt="南"></SvgButton></div>
          <div className={`controls-w controls-${controlsDisabled[3]}`} onClick={onControlClick('w')}><SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-compass/arrow-west-button`} src1=".svg" src2="-select.svg" alt="西"></SvgButton></div>
        </div>

        <div className={`nautical-chart nautical-chart-difficulty-${gameDifficulty.difficulty}`}>
          {nauticalChart.map.map(clss =>
            <div className={`tile ${clss.map(x => `tile_${x}`).join(' ')}`}></div>
          )}
          <div className={`ship ship-${currentDir} ship-pos-${currentPos} ship-${shipState} ship-move-${shipMoveState}`}></div>
        </div>

        <GameCompassHintsAndDescriptionModal />

        <GameCompassPreGame onFinish={onIntroFinish} />
      </div>
    </div>
  )
}

export default GameCompassGame;
